import Navbar from "./components/Navbar"
import Hero from "./components/Hero"
import Highlights from "./components/Highlights"
import Model from "./components/Model"
import Features from "./components/Features"
import HowItWork from "./components/HowItWork"
import Footer from "./components/Footer"
/*
import * as Sentry from '@sentry/react'; */
const  App = () => { 
  return (
    <main className="bg-black">
      <Navbar />
      <Hero />
      <Highlights />
      <Model />
      <Features />
      <HowItWork />
      <Footer />
    </main>
  )
}

export default App;
